<template lang="pug">
#legal-links
  RouterLink(:to="{name: 'privacy'}"  target="_blank") Privacy
  span -
  RouterLink(:to="{name: 'tos'}" target="_blank") Terms
  span -
  RouterLink(:to="{name: 'about'}" target="_blank") About
</template>

<script>
export default {
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  methods: {},

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
